import { PreviewSchedulesDataset } from "../previewTypes";

export const SCHEDULES_DATASET: PreviewSchedulesDataset = {
    shape: "schedules",
    scheduleHeader: "",
    percentHeader: "% of total",
    percentBase: 1636586,
    rows: [
        {
            id: "annual",
            label: "Annual",
            kind: "line",
            depth: 0,
            cells: {
                beginning: 1110000,
                additions: 410000,
                recognized: -540000,
                adjustments: -1249.5,
                ending: 978750.5,
            },
        },
        {
            id: "annual-acme",
            label: "Acme Corp",
            kind: "line",
            depth: 1,
            cells: {
                beginning: 700000,
                additions: 260000,
                recognized: -335000,
                adjustments: -4500.25,
                ending: 620499.75,
            },
        },
        {
            id: "annual-acme-1",
            label: "Acme Corp",
            kind: "line",
            depth: 2,
            cells: {
                beginning: 520000,
                additions: 200000,
                recognized: -260000,
                adjustments: 0,
                ending: 460000,
            },
        },
        {
            id: "annual-acme-2",
            label: "Acme Corp",
            kind: "line",
            depth: 2,
            cells: {
                beginning: 180000,
                additions: 60000,
                recognized: -75000,
                adjustments: -4500.25,
                ending: 160499.75,
            },
        },
        {
            id: "annual-globex",
            label: "Globex",
            kind: "line",
            depth: 1,
            cells: {
                beginning: 410000,
                additions: 150000,
                recognized: -205000,
                adjustments: 3250.75,
                ending: 358250.75,
            },
        },
        {
            id: "annual-globex-1",
            label: "Globex",
            kind: "line",
            depth: 2,
            cells: {
                beginning: 410000,
                additions: 150000,
                recognized: -205000,
                adjustments: 3250.75,
                ending: 358250.75,
            },
        },
        {
            id: "annual-total",
            label: "Total Annual",
            kind: "total",
            depth: 1,
            hasTopBorder: true,
            cells: {
                beginning: 1110000,
                additions: 410000,
                recognized: -540000,
                adjustments: -1249.5,
                ending: 978750.5,
            },
        },
        {
            id: "retainer",
            label: "Retainer",
            kind: "line",
            depth: 0,
            cells: {
                beginning: 710640,
                additions: 275220,
                recognized: -320310,
                adjustments: -7714.5,
                ending: 657835.5,
            },
        },
        {
            id: "retainer-initech",
            label: "Initech",
            kind: "line",
            depth: 1,
            cells: {
                beginning: 305640,
                additions: 95220,
                recognized: -120310,
                adjustments: 85.5,
                ending: 280635.5,
            },
        },
        {
            id: "retainer-initech-1",
            label: "Initech",
            kind: "line",
            depth: 2,
            cells: {
                beginning: 305000,
                additions: 95000,
                recognized: -120000,
                adjustments: 0,
                ending: 280000,
            },
        },
        {
            id: "retainer-initech-2",
            label: "Initech",
            kind: "line",
            depth: 2,
            cells: {
                beginning: 640,
                additions: 220,
                recognized: -310,
                adjustments: 85.5,
                ending: 635.5,
            },
        },
        {
            id: "retainer-umbrella",
            label: "Umbrella",
            kind: "line",
            depth: 1,
            cells: {
                beginning: 405000,
                additions: 180000,
                recognized: -200000,
                adjustments: -7800,
                ending: 377200,
            },
        },
        {
            id: "retainer-umbrella-1",
            label: "Umbrella",
            kind: "line",
            depth: 2,
            cells: {
                beginning: 405000,
                additions: 180000,
                recognized: -200000,
                adjustments: -7800,
                ending: 377200,
            },
        },
        {
            id: "retainer-total",
            label: "Total Retainer",
            kind: "total",
            depth: 1,
            hasTopBorder: true,
            cells: {
                beginning: 710640,
                additions: 275220,
                recognized: -320310,
                adjustments: -7714.5,
                ending: 657835.5,
            },
        },
        {
            id: "grand-total",
            label: "Total",
            kind: "total",
            depth: 0,
            hasTopBorder: true,
            cells: {
                beginning: 1820640,
                additions: 685220,
                recognized: -860310,
                adjustments: -8964,
                ending: 1636586,
            },
        },
    ],
};
